export function printContract(html: string) {
  const iframe = document.createElement('iframe')
  iframe.style.position = 'fixed'
  iframe.style.left = '-9999px'
  iframe.style.width = '0'
  iframe.style.height = '0'
  document.body.appendChild(iframe)

  const doc = iframe.contentDocument || iframe.contentWindow?.document
  if (!doc) {
    document.body.removeChild(iframe)
    return
  }

  doc.open()
  doc.write(`<!DOCTYPE html>
<html><head><meta charset="utf-8">
<style>
  @page { size: A4; margin: 20mm; }
  body { margin: 0; padding: 0; }
</style>
</head><body>${html}</body></html>`)
  doc.close()

  iframe.contentWindow?.focus()
  iframe.contentWindow?.print()

  const cleanup = () => {
    try {
      document.body.removeChild(iframe)
    } catch {
      // already removed
    }
  }
  iframe.contentWindow?.addEventListener('afterprint', cleanup)
  setTimeout(cleanup, 60000)
}
